import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const TaxInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Tax Information">
            <DataRow label="Tax Rate" value={`${pdfData.tax_rate}%`} isLast/>
        </Panel>
    )
}
